export default __webpack_public_path__ + "static/mobile-bg-2586dee556be80fbf4a3fe7f3acf861c.jpg";